import { Card as CardModel } from "@/types/v2";
import {
  Card as BaseCard,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/Base/Card";
import { AttachmentsMain } from "@/components/Common/Attachments/AttachmentsMain";
import { cardAttachmentsPath, cardPath } from "@/repositories/attachment";
import { RO_SECTION_TITLE_CLASS } from "@/components/Common/RoDetailsPanel/roPanelStyles";
import { useRoles } from "@/hooks/useRoles";
import { useFeature } from "@/hooks/useFeatures";
import { FEATURE_FLAGS } from "@/types/v2";
import { cn } from "@/lib/utils";

export interface RoAttachmentsCardProps {
  cardData: CardModel;
  shopId: string;
}

export const RoAttachmentsCard = ({
  cardData,
  shopId,
}: RoAttachmentsCardProps) => {
  const isAttachmentsEnabled = useFeature(FEATURE_FLAGS.isAttachmentsEnabled);
  const { isViewOnly } = useRoles();

  if (!isAttachmentsEnabled) return null;

  return (
    <BaseCard className="bg-white print:break-inside-avoid print:border-gray-300 print:bg-white print:p-2">
      <CardHeader>
        <CardTitle className={cn(RO_SECTION_TITLE_CLASS, "print:text-lg")}>
          Attachments
        </CardTitle>
      </CardHeader>
      <CardContent>
        <AttachmentsMain
          shopId={shopId}
          entityPath={cardPath(shopId, cardData.id)}
          attachmentsPath={cardAttachmentsPath(shopId, cardData.id)}
          canModify={!isViewOnly}
        />
      </CardContent>
    </BaseCard>
  );
};
